export const educationData = [
    {
        id: 1,
        institution: 'Kalpataru Institute of Technology Tiptur',
        course: 'Bachelor of Engineering in Computer Science',
        // startYear: 'CGPA',
        // endYear: '8.00'
    },
    {
        id: 2,
        institution: 'Sri Jagadguru Chandrashekhara Bharathi Memorial College Sringeri',
        course: 'PUC',
        // startYear: '2020',
        // endYear: '2022'
    },
    {
        id: 3,
        institution: 'Kittur Rani Chennamma Residential School Sokke',
        course: 'SSLC',
        
        // endYear: '2020'
    },
]